export const selectIsFetchingRegistration = state => state.registration.isFetching

export const selectRegistrationStatus = state => state.registration.status

export const selectLicenses = state => state.registration.licenses

export const selectRegistration = state => state.registration
